var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDollhouseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.48826 2.93928C8.76956 2.65797 9.15109 2.49994 9.54892 2.49994H20.6347C21.187 2.49994 21.6347 2.94766 21.6347 3.49994V14.5857C21.6347 14.9835 21.4767 15.3651 21.1954 15.6464L15.7812 21.0606C15.4998 21.3419 15.1183 21.4999 14.7205 21.4999H3.6347C3.08242 21.4999 2.6347 21.0522 2.6347 20.4999V9.41415C2.6347 9.01633 2.79274 8.6348 3.07404 8.35349L8.48826 2.93928ZM19.9276 3.49994H9.6347V8.49994H14.9276L19.9276 3.49994ZM14.6347 9.49994H9.6347V14.4999H14.6347V9.49994ZM14.6347 15.4999H9.34181L4.34181 20.4999H14.6347V15.4999ZM15.6347 19.7928V15.4999H19.9276L15.6347 19.7928ZM20.6347 14.4999H15.6347V9.20705L20.6347 4.20705V14.4999ZM3.6347 19.7928V9.49994H8.6347V14.7928L3.6347 19.7928ZM8.6347 8.49994V4.20705L4.34181 8.49994H8.6347Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollhouseIcon);
export default __webpack_public_path__ + "static/media/dollhouse-icon.a8f47b179557c5f23b74e69a5009bcc7.svg";
export { ForwardRef as ReactComponent };